export default "__VITE_ASSET__Bj$yWjZ5__"